import { ACTION_TYPES_MAP } from './action-types/action-types.const';
import ALERT_STATUSES from './alert-statuses.json';

// private

const getClientAlert = (id, actionType, archived, status, metadata = {}) => ({
	id,
	action_type: actionType,
	archived,
	entity_id: null,
	entity_type: null,
	related_entities_links: [],
	status,
	metadata,
	after_user_interaction: false,
});

const {
	ALLOW_EXTENSION_INJECTION_ACTION_TYPE: ALLOW_EXTENSION_INJECTION_ALERT_ID,
	INSTALL_EXTENSION_ACTION_TYPE: ALLOW_INSTALL_EXTENSION_ALERT_ID,
} = ACTION_TYPES_MAP;

// public

const getMetadataForAlert = (alertTitle, actionTitle, extraData) => ({
	title: alertTitle,
	action_title: actionTitle,
	...extraData,
});

const getMetadataForInstallExtensionAlert = () =>
	getMetadataForAlert('Install the extension to enable features in your apps', 'Open Chrome store', {
		redirect_url: process.env.VUE_APP_CHROME_EXTENSION_APP_URL,
		subtitle: 'Optional - tools work without the extension',
	});

const getAllowExtensionInjectionAlert = (isExtensionInstalled, doesExtensionHasInjectionPermissions) =>
	getClientAlert(
		ALLOW_EXTENSION_INJECTION_ALERT_ID,
		ALLOW_EXTENSION_INJECTION_ALERT_ID,
		doesExtensionHasInjectionPermissions || !isExtensionInstalled,
		isExtensionInstalled && doesExtensionHasInjectionPermissions ? ALERT_STATUSES.COMPLETED : ALERT_STATUSES.ACTION_REQUIRED
	);

const getInstallExtensionAlert = (isExtensionInstalled) =>
	getClientAlert(
		ALLOW_INSTALL_EXTENSION_ALERT_ID,
		ACTION_TYPES_MAP.REDIRECT_TO_URL,
		isExtensionInstalled,
		isExtensionInstalled ? ALERT_STATUSES.COMPLETED : ALERT_STATUSES.ACTION_REQUIRED,
		getMetadataForInstallExtensionAlert()
	);

const ClientAlertsService = { getAllowExtensionInjectionAlert, getInstallExtensionAlert };

export default ClientAlertsService;
